import type { SEOProps } from '@/components/SEO';
import {
  buildHarborSoftwareApplicationJsonLd,
  HARBOR_FACTS,
} from '@/lib/harbor-facts';

/**
 * Canonical metadata for the real landing page. Shared by the control page and
 * the motion arm when it is rendered at `/` during the A/B test, so both arms
 * keep the same indexable title/description/canonical URL.
 */
export const landingSeoProps: SEOProps = {
  title: 'Harbor: Co-Parenting App for Expenses, Messaging & Custody',
  description: HARBOR_FACTS.quote,
  path: '/',
  jsonLd: [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Harbor',
      url: 'https://harborcoparent.com',
      logo: 'https://harborcoparent.com/favicon.png',
      description:
        'Co-parenting app for shared expenses, secure messaging, custody scheduling, and court-ready records.',
    },
    buildHarborSoftwareApplicationJsonLd(),
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Harbor',
      url: 'https://harborcoparent.com',
    },
  ],
};
